export const GET_WORKOUT_BY_ID_REQUEST = 'GET_WORKOUT_BY_ID_REQUEST';
export const GET_WORKOUT_BY_ID_SUCCESS = 'GET_WORKOUT_BY_ID_SUCCESS';
export const GET_WORKOUT_BY_ID_FAILED = 'GET_WORKOUT_BY_ID_FAILED';

export const GET_WORKOUT_STOCK_IMAGE_REQUEST = 'GET_WORKOUT_STOCK_IMAGE_REQUEST';
export const GET_WORKOUT_STOCK_IMAGE_SUCCESS = 'GET_WORKOUT_STOCK_IMAGE_SUCCESS';
export const GET_WORKOUT_STOCK_IMAGE_FAILED = 'GET_WORKOUT_STOCK_IMAGE_FAILED';

export const UPLOAD_WORKOUT_IMAGE_REQUEST = 'UPLOAD_WORKOUT_IMAGE_REQUEST';
export const UPLOAD_WORKOUT_IMAGE_SUCCESS = 'UPLOAD_WORKOUT_IMAGE_SUCCESS';
export const UPLOAD_WORKOUT_IMAGE_FAILED = 'UPLOAD_WORKOUT_IMAGE_FAILED';

export const CREATE_WORKOUT_REQUEST = 'CREATE_WORKOUT_REQUEST';
export const CREATE_WORKOUT_SUCCESS = 'CREATE_WORKOUT_SUCCESS';
export const CREATE_WORKOUT_FAILED = 'CREATE_WORKOUT_FAILED';

export const GET_PLANNED_WORKOUTS_REQUEST = 'GET_PLANNED_WORKOUTS_REQUEST';
export const GET_PLANNED_WORKOUTS_SUCCESS = 'GET_PLANNED_WORKOUTS_SUCCESS';
export const GET_PLANNED_WORKOUTS_FAILED = 'GET_PLANNED_WORKOUTS_FAILED';

export const GET_WORKOUTS_OF_THE_DAY_BY_DATE_RANGE_REQUEST = 'GET_WORKOUTS_OF_THE_DAY_BY_DATE_RANGE_REQUEST';
export const GET_WORKOUTS_OF_THE_DAY_BY_DATE_RANGE_SUCCESS = 'GET_WORKOUTS_OF_THE_DAY_BY_DATE_RANGE_SUCCESS';
export const GET_WORKOUTS_OF_THE_DAY_BY_DATE_RANGE_FAILED = 'GET_WORKOUTS_OF_THE_DAY_BY_DATE_RANGE_FAILED';

export const ADD_WORKOUT_OF_THE_DAY_REQUEST = 'ADD_WORKOUT_OF_THE_DAY_REQUEST';
export const ADD_WORKOUT_OF_THE_DAY_SUCCESS = 'ADD_WORKOUT_OF_THE_DAY_SUCCESS';
export const ADD_WORKOUT_OF_THE_DAY_FAILED = 'ADD_WORKOUT_OF_THE_DAY_FAILED';

export const GET_WORKOUT_OF_THE_WEEK_REQUEST = 'GET_WORKOUT_OF_THE_WEEK_REQUEST';
export const GET_WORKOUT_OF_THE_WEEK_SUCCESS = 'GET_WORKOUT_OF_THE_WEEK_SUCCESS';
export const GET_WORKOUT_OF_THE_WEEK_FAILED = 'GET_WORKOUT_OF_THE_WEEK_FAILED';

export const ADD_WORKOUT_OF_THE_WEEK_REQUEST = 'ADD_WORKOUT_OF_THE_WEEK_REQUEST';
export const ADD_WORKOUT_OF_THE_WEEK_SUCCESS = 'ADD_WORKOUT_OF_THE_WEEK_SUCCESS';
export const ADD_WORKOUT_OF_THE_WEEK_FAILED = 'ADD_WORKOUT_OF_THE_WEEK_FAILED';



// WEBPACK FOOTER //
// ./src/Store/ActionTypes/WorkoutsActionTypes.js